import React, { useEffect, useState } from "react";
import { Camera, Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { btn, btnPrimary, selectCls, Field } from "@/components/accounting/ui";

export const CameraCapture = ({ file, meta, defaultCategory, label, onClose, onRetake, onSave }) => {
  const [url, setUrl] = useState(null);
  const [category, setCategory] = useState(defaultCategory);
  const [docType, setDocType] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!file) return undefined;
    const u = URL.createObjectURL(file);
    setUrl(u);
    setCategory(defaultCategory);
    setDocType("");
    return () => URL.revokeObjectURL(u);
  }, [file, defaultCategory]);

  const types = meta.categories.find((c) => c.id === category).types;
  const save = async () => {
    setBusy(true);
    await onSave({ category, docType });
    setBusy(false);
  };

  return (
    <Dialog open={!!file} onOpenChange={(o) => !o && !busy && onClose()}>
      <DialogContent className="max-w-md max-h-[92vh] overflow-y-auto" data-testid="acc-camera-dialog">
        <DialogHeader>
          <DialogTitle>Foto als Beleg speichern</DialogTitle>
          <DialogDescription>Wird dem Monat {label} zugeordnet. Das Originalfoto bleibt unverändert erhalten.</DialogDescription>
        </DialogHeader>
        <div className="rounded-lg overflow-hidden bg-elevated border border-line h-[42vh] flex items-center justify-center">
          {url && <img src={url} alt="Vorschau des Belegs" className="max-h-full max-w-full object-contain" data-testid="acc-camera-preview" />}
        </div>
        <div className="grid grid-cols-2 gap-3">
          <Field label="Kategorie">
            <select value={category} onChange={(e) => { setCategory(e.target.value); setDocType(""); }} className={`${selectCls} w-full`} data-testid="acc-camera-category">
              {meta.categories.map((c) => <option key={c.id} value={c.id}>{c.label}</option>)}
            </select>
          </Field>
          <Field label="Belegart">
            <select value={docType} onChange={(e) => setDocType(e.target.value)} className={`${selectCls} w-full`} data-testid="acc-camera-doctype">
              <option value="">Später festlegen</option>
              {types.map((t) => <option key={t.id} value={t.id}>{t.label}</option>)}
            </select>
          </Field>
        </div>
        <div className="flex gap-2 justify-end pt-1">
          <button type="button" onClick={onRetake} disabled={busy} className={btn} data-testid="acc-camera-retake-btn"><Camera size={13} /> Neu aufnehmen</button>
          <button type="button" onClick={save} disabled={busy} className={btnPrimary} data-testid="acc-camera-save-btn">
            {busy && <Loader2 size={14} className="animate-spin" />} Speichern
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default CameraCapture;
